module.exports = __webpack_public_path__ + "static/media/White 3-1.21f7093f.jpg";